import type { Alert, Severity } from '../api/types/hd';
import { Badge, type Tone } from './Badge';
import { sortAlerts } from './alertSort';

const TONE: Record<Severity, Tone> = { critical: 'red', warning: 'orange', info: 'blue' };
const label = (s: Severity) => s.charAt(0).toUpperCase() + s.slice(1);

export function AlertList({
  alerts,
  limit,
  onSelect,
}: {
  alerts: readonly Alert[];
  limit?: number;
  onSelect?: (a: Alert) => void;
}) {
  const rows = sortAlerts(alerts).slice(0, limit ?? alerts.length);
  return (
    <div role="list">
      {rows.map((a) => (
        <button key={a.id} type="button" role="listitem" className="alert-row" onClick={() => onSelect?.(a)}>
          <Badge tone={TONE[a.severity]}>{label(a.severity)}</Badge>
          <span className="alert-title">{a.title}</span>
          <span className="t-foot">{a.detail}</span>
        </button>
      ))}
    </div>
  );
}
